<div class="form-group" [formGroup]="form">
    <div [ngSwitch]="field.type">
        <app-dynamic-input *ngSwitchCase="'text'" [field]="field"  [form]="form"></app-dynamic-input>
        <app-dynamic-input *ngSwitchCase="'number'" [field]="field" [className]="validationClass" [form]="form"></app-dynamic-input>
    </div>
</div>